import React, { useState } from 'react';
import './App.css'; 

const AssignmentApp = () => {

  const [cellColors, setCellColors] = useState(Array(9).fill("white"));
  
  const [clickedCells, setClickedCells] = useState([]);

  
  const handleCellClick = (index) => {
    
    if (index === 8) {
      
      clickedCells.forEach((cellIndex, idx) => {
        
        setTimeout(() => {
          setCellColors((prevColors) => {
            const updatedColors = [...prevColors];
            updatedColors[cellIndex] = "orange";
            return updatedColors;
          });
        }, idx * 300); 
      });

      
      setClickedCells([]);
    } else {
      
      setCellColors((prevColors) => {
        const updatedColors = [...prevColors];
        updatedColors[index] = "green";
        return updatedColors;
      });

      
      setClickedCells((prev) => [...prev, index]);
    }
  };

  
  const resetMatrix = () => {
    setCellColors(Array(9).fill("white"));
    setClickedCells([]);
  };

  return (
    <div className="assignment-container">
      
      
      <div className="question-answer">
        <div className="question">
          <h3>1. Create a 3x3 matrix</h3>
          <h3>2. When you click on a box - color should change to green</h3>
          <h3>3. When you click on the last box, all colors should change to orange in sequence of their clicks (original clicks)</h3>
        </div>
        <div className="answer">
          {/* Right side matrix */}
          <div className="matrix-grid">
            {cellColors.map((color, index) => (
              <div
                key={index}
                onClick={() => handleCellClick(index)}
                className={`matrix-cell ${color}`}
              />
            ))}
          </div>
          <button className="reset-button" onClick={resetMatrix}>Reset Colors</button>
        </div>
      </div>
    </div>
  );
};

export default AssignmentApp;
